import * as React from "react";
const SvgFiRrPanorama = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-panorama_svg__a)">
      <path
        fill="#062147"
        d="M17 11c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2M22.717.334a2.53 2.53 0 0 0-2.575.028C18.809 1.155 15.347 3 12 3S5.191 1.155 3.858.362A2.53 2.53 0 0 0 1.283.334 2.51 2.51 0 0 0 0 2.542v18.913a2.51 2.51 0 0 0 1.283 2.208c.81.46 1.772.45 2.575-.028C5.19 22.843 8.648 21 12 21s6.811 1.843 8.142 2.635c.41.244.861.366 1.312.366.433 0 .866-.112 1.263-.338A2.51 2.51 0 0 0 24 21.455V2.542A2.51 2.51 0 0 0 22.717.334M2.271 2.072a.55.55 0 0 1 .564.009C4.31 2.959 8.156 5 12 5s7.689-2.041 9.165-2.919a.55.55 0 0 1 .564-.009.52.52 0 0 1 .271.47v18.913l-.001.031-10.313-10.314c-1.51-1.511-4.146-1.513-5.657 0L2 15.2V2.542c0-.274.17-.412.271-.47m.564 19.844a.55.55 0 0 1-.564.009.52.52 0 0 1-.271-.47v-3.427l5.443-5.442c.756-.757 2.073-.755 2.829 0l7.768 7.768C16.304 19.638 14.154 19 12.001 19c-3.848 0-7.692 2.039-9.166 2.916"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-panorama_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPanorama;
